import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const BrandCtx = createContext({ brand_name: "iYeneh Connect" });
export const useBrand = () => useContext(BrandCtx);

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState({
    brand_name: "iYeneh Connect",
    tagline: "One Account. One Wallet. Every Connection.",
    currency: "USD",
  });
  useEffect(() => {
    api.get("/brand").then(({ data }) => { if (data && data.brand_name) setBrand(data); }).catch(() => {});
  }, []);
  return <BrandCtx.Provider value={brand}>{children}</BrandCtx.Provider>;
}
